<template>
    <v-container fluid class="scroll-y fullscreen grey lighten-2" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="primary"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitleFull }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    :to="{ name: 'New Property' }"
                    tile
                    depressed
                    large
                    >
                        <v-icon dark>mdi-plus</v-icon>
                        Add New
                </v-btn>

                <v-icon class="ml-4" large dark @click="drawer = !drawer">mdi-magnify</v-icon>
            </v-toolbar>
        </v-card>
        <v-container fluid grid-list-md>
            <v-layout row wrap>
                <v-flex d-flex xs12 sm6 md2 child-flex v-for="property in properties" :key="`property-${property.id}`">
                    <v-card>
                        <template v-if="property.image != null">
                                <v-img
                                :src="`http://appapi.commercialpropertiesinc.net/storage/uploads/files/${property.image.file}`"
                                class="white--text align-end"
                                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                height="200px"
                                >
                                    <v-btn :to="`/property/edit/${property.id}`" class="overlay-click"><v-card-title v-html="property.street_address + '<br/>' + property.city + ', ' + property.state + ' ' + property.zip"></v-card-title></v-btn>
                                </v-img>
                        </template>
                        <template v-else>
                            <v-img
                            :src="noimage"
                            class="white--text align-end"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            height="200px"
                            >
                                <v-btn :to="`/property/edit/${property.id}`" class="overlay-click"><v-card-title v-html="property.street_address + '<br/>' + property.city + ', ' + property.state + ' ' + property.zip"></v-card-title></v-btn>
                            </v-img>
                        </template>
                        <v-card-actions>
                            <h4>{{ 'Property # ' + property.property_id }}</h4>
                            <v-spacer></v-spacer>

                            <v-btn icon :to="`/property/edit/${property.id}`">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>

                            <v-btn color="red" icon @click.stop="deleteItem(property)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card color="red">
            <v-card-title class="subtitle-2 justify-center white--text">Are you sure to delete this item?</v-card-title>
            <v-card-actions class="red darken-4">
              <v-spacer></v-spacer>
              <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">Yes</v-btn>
              <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <FilterProperties :show="drawer" :filter="filter" :routekey="routeKey" @update-keyword="updateKeyword" @update-drawer="updateDrawer" @update-status="updateStatus" @update-daterange="updateDaterange"  @update-building_type="updateBuildingType" @update-construction_type="updateConstructionType" @update-roof_type="updateRoofType" @update-user="updateUser" @update-search_field="updateSearchField" @update-search_type="updateSearchType" @submit-search="submitSearch"/>
        <Dialog :dialog="dialog" :property="editedItem" @update-dialog="updateDialog">
    </v-container>
</template>

<script>
import axios from 'axios'
import FilterProperties from '../../components/FilterProperties.vue'
import Dialog from '../../components/Dialog.vue'
import noimage from "@/assets/noimage.jpg"

export default {
    data() {
        return {
            dialog: false,
            noimage: noimage,
            drawer: false,
            loading: true,
            properties: [],
            totalProperties: 0,
            numberOfPages: 0,
            itemsPerPage: 10,
            page: 1,
            options: {
                itemsPerPage: 100,
                page: 1,
            },
            pageTitle: '',
            apiUrl: '',
            routeKey: '',
            filter: {
                keyword: "",
                building_type: [],
                construction_type: [],
                roof_type: [],
                user: [],
                dates: [],
                status: [],
                search_field: 'address',
                search_type: 'equal'
            },
            dialogDelete: false,
            editedItem: [],
            defaultItem: [],
        }
    },
    created() {
        this.pageTitle = this.$route.meta.title
        this.routeKey = this.$route.meta.key
        if(this.routeKey == 'new') {
            this.filter.status = 'confirmed'
        } 
    },
    components: {
        FilterProperties,
        Dialog
    },
    mounted() {
        this.getProperties()
    },
    computed: {
        pageTitleFull() {
            if(this.loading == true) {
                return 'Loading...'
            } else {
                return this.pageTitle
            }
        },
    },
    watch: {
        options: {
            handler() {
                this.getProperties();
            },
        },
        deep: true,
    },
    methods: {
        openDialog(property) {
            this.editedItem = property
            this.dialog = true
        },
        updateDialog(val) {
            this.dialog = val
        }, 
        getProperties() {
            this.loading = true
            const { page, itemsPerPage } = this.options;

            axios.get('properties?size=' + itemsPerPage + '&page=' + page, {
                params: this.filter
            })
            .then(response => {
                this.loading = false
                this.properties = response.data.data
                this.numberOfPages = response.data.last_page
                this.totalProperties = response.data.total
                this.$nextTick()
            })
        },
        deleteItem (item) {
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },
        deleteItemConfirm () {
            this.loading = true
            axios.delete('properties/' + this.editedItem.id)
                .then(() => {
                    this.closeDelete()
                    this.getProperties()
                    this.$nextTick()
                })
        },
        closeDelete () {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
            })
        },
        updateDrawer(val) {
            this.drawer = val
        },
        updateKeyword(val) {
            this.filter.keyword = val
        },
        updateBuildingType(val) {
            this.filter.building_type = val
            this.getProperties()
        },
        updateConstructionType(val) {
            this.filter.construction_type = val
            this.getProperties()
        },
        updateRoofType(val) {
            this.filter.roof_type = val
            this.getProperties()
        },
        updateUser(val) {
            this.filter.user = val
            this.getProperties()
        },
        updateSearchField(val) {
            this.filter.search_field = val
            this.getProperties()
        },
        updateSearchType(val) {
            this.filter.search_type = val
            this.getProperties()
        },
        updateStatus(val) {
            this.filter.status = val
            this.getProperties()
        },
        updateDaterange(val) {
            this.filter.daterange = val
        },
        submitSearch() {
            this.getProperties()
        },
    }
}
</script>
<style lang="sass" scoped>
.theme--light 
    .v-content
        background: #ffffff

.fullscreen
    background: #fff
    height: 100%

.w-100
    width: 100%
    .v-btn 
        width: 100%

.v-list-item__action
    .v-btn
        &:not(.v-btn--round)
            &.v-size--small
                height: 42px

.v-chip 
    border-radius: 0!important

.customers-count
    font-size: 14px


</style>

<style lang="sass">
.v-text-field
    &>.v-input__control
        &>.v-text-field__details
            margin-bottom: 0px!important
            padding: 0

.v-card__title 
    white-space: break-spaces
    font-size: 1em
    line-height: 1.4em

.overlay-click
    position: absolute
    width: 100%
    height: 100%!important
    top: 0
    left: 0
    background: transparent!important
    color: #fff!important

.overlay-click
    span.v-btn__content
        position: absolute
        bottom: 0
        width: 100%
        display: block
</style>